import * as React from 'react'
import UIMessages from '../../../../utils/ui-messages'
import HorizontalSelector from './HorizontalSelectorCustom'
import HorizontalSelectorItem from './HorizontalSelectorItemCustom'
import CheckMark from '../../../icons/ui/CheckMark'
import * as classNames from 'classnames'
import TabBar from '../../../ui/entity/EntityTabBar'
import TabBarItem from '../../../ui/entity/EntityTabBarItem'
import { Link } from 'react-router-dom'

export interface ICreateOrganizationStepSelectorProps {
  path: string
  pathname: string
  isSaved: boolean
  isStepComplete: (step: number) => boolean
  orgId: string
}

enum viewOrganizationNavRoutes {
  ORGANIZATION_INFO = 'organization-info',
  SUBSCRIPTION_PLAN = 'organization-subscription',
  SERVICE_AREA = 'organization-location',
  LEGAL_ENTITY = 'legal-entity',
  BANK_ACCOUNT = 'bank-account'
}

const CreateOrganizationStepSelector = ({
  path,
  pathname,
  isSaved,
  isStepComplete,
  orgId
}: ICreateOrganizationStepSelectorProps) => {
  const StepIcon = (props: { stepn: string; isSelected: boolean; isCompleted: boolean }) => {
    return (
      <div
        className='inline-block mr1'
        style={{
          width: '32px',
          height: '32px',
          lineHeight: '32px',
          borderRadius: '50%',
          textAlign: 'center',
          color: props.isCompleted ? 'white' : 'black',
          backgroundColor: props.isCompleted ? '#37C47E' : props.isSelected ? 'white' : 'transparent',
          border: '2px solid ' + (!props.isCompleted ? (props.isSelected ? '#37C47E' : '#979797') : '#37C47E')
        }}
      >
        {props.isCompleted ? <CheckMark className='icon--small ' /> : props.stepn}
      </div>
    )
  }

  const isPathOrganizationInfo = /\/organization-info/.test(pathname)
  const isPlanSubscription = /\/organization-subscription/.test(pathname)
  const isPathServiceArea = /\/organization-location/.test(pathname)
  const isPathLegalEntity = /\/legal-entity/.test(pathname)
  const isPathBankAccount = /\/bank-account/.test(pathname)

  const isActiveLink = (linkPath?: string) => {
    const fullLink = linkPath ? `${pathname}/${linkPath}` : pathname
    return fullLink === pathname
  }

  console.log('org id: ' + orgId)

  return (
    <div>
      <TabBar>
        <TabBarItem active={isPathOrganizationInfo}>
          <Link to={`${viewOrganizationNavRoutes.ORGANIZATION_INFO}`}>Organization Info</Link>
        </TabBarItem>
        <TabBarItem active={isPlanSubscription}>
          <Link to={`${viewOrganizationNavRoutes.SUBSCRIPTION_PLAN}`}>Subscription Plan</Link>
        </TabBarItem>
        <TabBarItem active={isPathServiceArea}>
          <Link to={`${viewOrganizationNavRoutes.SERVICE_AREA}`}>Service AreA</Link>
        </TabBarItem>
        <TabBarItem active={isPathLegalEntity}>
          <Link to={`${viewOrganizationNavRoutes.LEGAL_ENTITY}`}>Legal Entity</Link>
        </TabBarItem>
        <TabBarItem active={isPathBankAccount}>
          <Link to={`${viewOrganizationNavRoutes.BANK_ACCOUNT}`}>Bank Account</Link>
        </TabBarItem>
      </TabBar>

      {/* <HorizontalSelector>
        <HorizontalSelectorItem isSelected={isPathOrganizationInfo}>
          <StepIcon stepn='1' isCompleted={isStepComplete(1)} isSelected={isPathOrganizationInfo} />
          <span
            style={{ color: isStepComplete(1) ? '#37C47E' : 'font-grey4' }}
            className={classNames(
              'font-normal uppercase weight-600',
              { 'font-grey2': isPathOrganizationInfo },
              { 'font-grey4': !isPathOrganizationInfo }
            )}
          >
            {UIMessages.common.organizationInfo}
          </span>
        </HorizontalSelectorItem>

        <HorizontalSelectorItem isSelected={isSubscriptionPlanSelect}>
          <StepIcon stepn='2' isCompleted={isStepComplete(2)} isSelected={isPathOrganizationInfo} />
          <span
            style={{ color: isStepComplete(1) ? '#37C47E' : 'font-grey4' }}
            className={classNames(
              'font-normal uppercase weight-600',
              { 'font-grey2': isSubscriptionPlanSelect },
              { 'font-grey4': !isSubscriptionPlanSelect }
            )}
          >
            {UIMessages.common.subscriptionPlan}
          </span>
        </HorizontalSelectorItem>

        <HorizontalSelectorItem isSelected={isPathOrganizationLocation}>
          <StepIcon stepn='3' isCompleted={isStepComplete(3)} isSelected={isPathOrganizationLocation} />
          <span
            style={{ color: isStepComplete(2) ? '#37C47E' : 'font-grey4' }}
            title={!isSaved ? UIMessages.common.saveOrganizationInfoBeforeContinue : ''}
            className={classNames(
              'font-normal uppercase weight-600',
              { 'font-grey2': isPathOrganizationLocation },
              { 'font-grey4': !isPathOrganizationLocation }
            )}
          >
            {UIMessages.common.organizationServiceArea}
          </span>
        </HorizontalSelectorItem>

        <HorizontalSelectorItem isSelected={isLegalEntity}>
          <StepIcon stepn='4' isCompleted={isStepComplete(4)} isSelected={isLegalEntity} />
          <span
            style={{ color: isStepComplete(3) ? '#37C47E' : 'font-grey4' }}
            title={!isSaved ? UIMessages.common.saveOrganizationInfoBeforeContinue : ''}
            className={classNames(
              'font-normal uppercase weight-600',
              { 'font-grey2': isLegalEntity },
              { 'font-grey4': !isLegalEntity }
            )}
          >
            {UIMessages.common.legalEntity}
          </span>
        </HorizontalSelectorItem>

        <HorizontalSelectorItem isSelected={isBankAccount}>
          <StepIcon stepn='5' isCompleted={isStepComplete(5)} isSelected={isBankAccount} />
          <span
            style={{ color: isStepComplete(4) ? '#37C47E' : 'font-grey4' }}
            title={!isSaved ? UIMessages.common.saveOrganizationInfoBeforeContinue : ''}
            className={classNames(
              'font-normal uppercase weight-600',
              { 'font-grey2': isBankAccount },
              { 'font-grey4': !isBankAccount }
            )}
          >
            {UIMessages.common.bankAccount}
          </span>
        </HorizontalSelectorItem>

        <div style={{ flex: 3 }}>&nbsp;</div>
      </HorizontalSelector> */}
    </div>
  )
}

export default CreateOrganizationStepSelector



// WEBPACK FOOTER //
// ./src/components/organizations/create/Selector/CreateOrganizationStepSelector.tsx